
























import {Component, Vue, Watch} from "vue-property-decorator";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import anime from 'animejs/lib/anime.es.js';
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";

@Component({
  components: {
    VueSlider,
  }
})

export default class ZoomSlider extends Vue {

  zoomFactor = 50;
  minScale = 0.2;
  maxScale = 1.5;

  dotOptions: Object = {
    tooltip: 'none',
    focusStyle: { boxShadow: 'none' },
    style: {
      backgroundColor: 'rgb(76, 76, 76)',
      backgroundImage: 'url(/svg/slider-handle.svg)',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      border: 'none',
      transition: 'none !important'
    }
  }

  railStyle: Object = { backgroundColor: 'transparent' }

  processStyle: Object = { backgroundColor: 'transparent' }

  @Watch('zoomFactor')
  onZoomChange(value: number) {
    const min = this.minScale;
    const max = this.maxScale;
    const range = max - min;
    const zoom = min + (value / 100) * range;
    this.setZoom(zoom);
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  get scaleCloud(): number {
    return this.$store.state.rhizome.scaleCloud;
  }

  set scaleCloud(value: number) {
    this.$store.commit('rhizome/setPropertyInState', { name: 'scaleCloud', value });
  }

  mounted() {
    if (!this.isKiosk) {
      window.addEventListener('mousewheel', this.scrollAction);
      window.addEventListener('DOMMouseScroll', this.scrollAction);
    } else {
      bus.$on(EventEmitter.Events.RESET_ZOOM, this.onResetZoom)
      bus.$on(EventEmitter.Events.SET_ZOOM, this.onSetZoom)
    }
  }

  scrollAction(event) {
    let delta = 0;

    if (!event) event = window.event;
    if (event.wheelDelta) {
      delta = event.wheelDelta/120;
    }
    else if (event.detail) {
      delta = -event.detail/3;
    }

    this.zoomCloud(delta);
  }

  zoomCloud(delta: number) {
    if (delta) {
      if ((this.scaleCloud <= 0.2 && delta < 0) || (this.scaleCloud >= 1.5 && delta > 0)) return;

      const cloud = document.querySelector('.rhizome-cloud') as HTMLElement

      if (cloud === null) {
        return
      }

      const transformParts = cloud.style.transform.split(' ');
      const x = +transformParts[0].replace('translateX(', '').replace('px)', '');
      const y = +transformParts[1].replace('translateY(', '').replace('px)', '');

      const oldScale = this.scaleCloud;
      this.scaleCloud += delta * 0.1;

      const ww = window.innerWidth;
      const wh = window.innerHeight;

      const ow = 10000;
      const oh = 10000;

      const cxFac = (-x + ww / 2) / (ow * oldScale);
      const cyFac = (-y + wh / 2) / (oh * oldScale);

      const cx = cxFac * ow * this.scaleCloud;
      const cy = cyFac * oh * this.scaleCloud;

      const tx = ww / 2 - cx;
      const ty = wh / 2 - cy;

      cloud.style.transform = `translateX(${tx}px) translateY(${ty}px) scale(${this.scaleCloud})`;
    }
  }

  setZoom(value: number) {
    const cloud = document.querySelector('.rhizome-cloud') as HTMLElement;

    const transformParts = cloud.style.transform.split(' ');
    const x = +transformParts[0].replace('translateX(', '').replace('px)', '');
    const y = +transformParts[1].replace('translateY(', '').replace('px)', '');

    const oldScale = this.scaleCloud;
    this.scaleCloud = value;

    const ww = window.innerWidth;
    const wh = window.innerHeight;

    const ow = 10000;
    const oh = 10000;

    const cxFac = (-x + ww / 2) / (ow * oldScale);
    const cyFac = (-y + wh / 2) / (oh * oldScale);

    const cx = cxFac * ow * this.scaleCloud;
    const cy = cyFac * oh * this.scaleCloud;

    const tx = ww / 2 - cx;
    const ty = wh / 2 - cy;

    cloud.style.transform = `translateX(${tx}px) translateY(${ty}px) scale(${this.scaleCloud})`;
  }

  onDrag() {
    const handle = (this.$refs.slider as Vue).$el.querySelector('.vue-slider-dot-handle') as HTMLElement;
    if (handle) {
      handle.classList.add('pressed');
    }
  }

  onDragEnd() {
    const handle = (this.$refs.slider as Vue).$el.querySelector('.vue-slider-dot-handle') as HTMLElement;
    if (handle) {
      handle.classList.remove('pressed');
    }
  }

  lerp(v0: number, v1: number, t: number) {
    return v0 * (1 - t) + v1 * t;
  }

  onResetZoom() {
    if (this.zoomFactor === 50) return;

    const start = this.zoomFactor;
    const end = 50;

    anime({
      duration: 2000,
      delay: 0,
      easing: 'easeInOutQuad',
      update: (state) => {
        const alpha = state.progress / 100;
        this.zoomFactor = this.lerp(start, end, alpha);
      }
    });
  }

  onSetZoom(zoom: number) {
    const min = this.minScale;
    const max = this.maxScale;
    const range = max - min;
    this.zoomFactor = (zoom - min) / range * 100;
  }

  destroyed() {
    if (!this.isKiosk) {
      window.removeEventListener('mousewheel', this.scrollAction);
      window.removeEventListener('DOMMouseScroll', this.scrollAction);
    } else {
      bus.$off(EventEmitter.Events.RESET_ZOOM, this.onResetZoom);
      bus.$off(EventEmitter.Events.SET_ZOOM, this.onSetZoom);
    }
  }
}
